<template>
  <div class="c" id="cos">
    <!-- 使用情况 -->
    <div class="c-use">
      <div class="c-condition">
      <header class="c-condition__header">使用情况</header>
     <div class="c-condition__flex">
        <div class="c-condition__number">
          <div class="fz-20">参与班级数</div>
          <div class="fz-40">
            <span class="mr-5">{{dataList.class_num}}</span>
            <span style="font-size:20px ;font-weight: 400;">个</span>
          </div>
        </div>
        <div class="c-condition__number">
          <div class="fz-20">发布测评数</div>
          <div class="fz-40">
            <span class="mr-5">{{dataList.evaluation_num}}</span>
            <span style="font-size:20px ;font-weight: 400;">个</span>
          </div>
        </div>
     </div>
    </div>
      <AccurateDistribute
        :data="dataList"/>
    </div>
    <!-- 学习数据 -->
    <div class="c-data">
       <header class="c-condition__header mr-0">学习数据</header>
        <ul class="c-data__analysis">
        <li>
          <div class="c-data__analysis__number">测评做题数</div>
          <div class="fz-40 mt-16">
            <span class="mr-5">{{dataList.evaluation_question_num}}</span>
            <span style="font-size:20px ;font-weight: 400;">道</span>
          </div>
        </li>
        <li>
          <div class="c-data__analysis__number">平均正答率</div>
          <div class="fz-40 mt-16">
            <span class="mr-5">{{dataList.avg_accuary}}</span>
            <span style="font-size:20px ;font-weight: 400;">%</span>
          </div>
        </li>
        <li>
          <div class="c-data__analysis__number">检测知识点数</div>
          <div class="fz-40 mt-16">
            <span class="mr-5">{{dataList.question_num}}</span>
            <span style="font-size:20px ;font-weight: 400;">个</span>
          </div>
          <div class="fz-16">
            <span class="avg_circle"></span>
            人均检测: <span class="avg_unit">{{dataList.avg_question_num}}个</span> </div>
        </li>
        <li>
          <div class="c-data__analysis__number">检测薄弱知识点数</div>
          <div class="fz-40 mt-16">
            <span class="mr-5">{{dataList.question_week_num}}</span>
            <span style="font-size:20px ;font-weight: 400;">个</span>
          </div>
          <div class="fz-16"><span class="avg_circle"></span>
          人均薄弱: <span class="avg_unit">{{dataList.avg_question_week_num}}个
            </span>
          </div>
        </li>
        <li>
          <div class="c-data__analysis__number">平均知识点掌握程度</div>
          <div class="fz-40 mt-16">
            <span class="mr-5">{{dataList.question_accuary}}</span>
            <span style="font-size:20px ;font-weight: 400;">%</span>
          </div>
        </li>
        <li>
          <div class="c-data__analysis__number">发布巩固练习数</div>
          <div class="fz-40 mt-16">
            <span class="mr-5">{{dataList.consolidate_num}}</span>
            <span style="font-size:20px ;font-weight: 400;">个</span>
          </div>
        </li>
        </ul>
    </div>
    <!-- 测评效果图 -->
    <div class="c-result">
      <div class="c-result__effect">
        <EvaluateEffect
        :graspList="dataList.avg_grasp"/>
      </div>
      <grade-bar
      :levelList="dataList.learn_level"/>
    </div>
    <!-- 知识图谱 -->
    <div style="position: relative">
      <header class="c-result__header">班级知识图谱</header>
      <!-- 班级选择 -->
      <div class="p-select">
        <el-select v-model="value" placeholder=""  @change="timeChange" popper-class="selectFrom">
          <el-option
            v-for="(item, index) in classList"
            :key="index"
            :label="item.class_name"
            :value="item.class_id"
           >
          </el-option>
        </el-select>
      </div>
        <div class="c-atlas__list__title" @click="subjectChange">
          <i class="el-icon-document t-color"></i>
          {{conditionNameList.subjectName}} /
          {{conditionNameList.versionsName}} /
          {{conditionNameList.gradeName}}
          <i class="el-icon-arrow-down el-icon--right right"></i>
        </div>
        <div class="bg"></div>
      <div v-if="isShow" class="change-select">
        <div class="change-select__down cb3">
          <div
            class="change-select__down__subject"
            @click="subjectClick(subject)"
            v-for="subject in subjectList"
            :class="{'active':subject.dl_subject_id ===conditionList.dLSubjectId }"
            :key="subject.subject_id">
            {{subject.code_name}}
          </div>
        </div>
        <div class="change-select__down">
          <div
            class="change-select__down__subject w-15"
            v-for="item in versionsList"
            @click="versionClick(item)"
            :class="{'active':item.dl_versions_id ===conditionList.bookVersionId }"
            :key="item.versions_id">
            {{item.versions_name}}
          </div>
        </div>
        <div class="change-select__down">
          <div
            class="change-select__down__subject w-15"
            v-for="grade in gradeList"
            @click="gradeClick(grade)"
            :class="{'active':grade.grade_id === conditionList.gradeId }"
            :key="grade.crm_grade_id">
            {{grade.grade_name}}
          </div>
        </div>
      </div>
      <div class="c-atlas">
      <div class="c-atlas__list">
        <ul>
          <li
            class="c-border"
            v-for="item in testList"
            @click="testChange(item)"
            :class="{'active':item.test_id === conditionList.testId }"
            :key="item.test_id">
            {{item.test_name}}
          </li>
        </ul>
      </div>
      <knowledge-atlas
      :data="knowledgeList"
      :edges="edges"
    />
    </div>
    </div>
  </div>
</template>

<script>
import GradeBar from './grade-bar.vue';
import KnowledgeAtlas from './knowledge-atlas.vue';
import AccurateDistribute from './accurate-distribute.vue';
import EvaluateEffect from './evaluate-effect.vue';
import { getAccurateCategory, getClassKnowledgeAtlas } from '@/api/pt';

export default {
  name: 'AccurateTeacher',
  components: {
    GradeBar,
    KnowledgeAtlas,
    AccurateDistribute,
    EvaluateEffect,
  },
  props: {
    dataList: {
      require: true,
      type: Object,
    },
  },
  computed: {
    edges() {
      if (!this.knowledgeList || !this.knowledgeList.length) {
        return [];
      }
      return this.knowledgeList.reduce((prev, cur) => {
        if (!cur.pre_lo_list || !cur.pre_lo_list.length) {
          return prev;
        }
        return prev.concat(cur.pre_lo_list.map((item) => ({
          source: item,
          target: cur.id,
        })));
      }, []);
    },
  },
  data() {
    return {
      subjectList: [],
      versionsList: [],
      gradeList: [],
      classList: [],
      testList: [],
      knowledgeList: [],
      isShow: false,
      value: '',
      conditionList: {
        crmSubjectId: '',
        dLSubjectId: '',
        bookVersionId: '',
        gradeId: '', //
        crmGradeId: '',
        testId: '',
        courseCode: '',
        sectionsId: '',
      },
      conditionNameList: {
        subjectName: '',
        versionsName: '',
        gradeName: '',
        testName: '',
      },
      timer: null,
    };
  },
  mounted() {
    this.getAccurateCategory('subjects');
    this.add();
  },
  watch: {
  },
  methods: {
    timeChange(val) {
      this.value = val;
      this.getClassKnowledgeAtlas();
    },
    subjectClick(subject) { // 切换学科
      this.knowledgeList = [];
      console.log(subject);
      this.conditionList.crmSubjectId = subject.crm_subject_id;
      this.conditionList.dLSubjectId = subject.dl_subject_id;
      this.getAccurateCategory('versions');
    },
    versionClick(value) { // 切换版本
      this.knowledgeList = [];
      this.conditionList.bookVersionId = value.dl_versions_id;
      this.conditionNameList.versionsName = value.versions_name;
      this.getAccurateCategory('grade');
    },
    gradeClick(grade) { // 切换年级
      this.knowledgeList = [];
      this.conditionList.gradeId = grade.grade_id;
      this.conditionList.crmGradeId = grade.crm_grade_id;
      this.conditionNameList.gradeName = grade.grade_name;
      this.getAccurateCategory('class');
      this.getAccurateCategory('test');
      this.isShow = false;
    },
    testChange(item) { // 课程切换
      this.conditionList.testId = item.test_id;
      this.conditionList.courseCode = item.course_code;
      this.conditionList.sectionsId = item.section_ids;
      this.getClassKnowledgeAtlas();
    },
    getClassKnowledgeAtlas() {
      getClassKnowledgeAtlas({
        course_code: this.conditionList.courseCode,
        test_id: this.conditionList.testId,
        section_ids: this.conditionList.sectionsId,
        subject_id: this.conditionList.dLSubjectId,
        textbook_id: this.conditionList.bookVersionId,
        class_id: this.value || '',
      }).then((res) => {
        this.knowledgeList = res.data.knowledge_list;
        this.getKnowledgeList();
      });
    },
    getKnowledgeList() {
      this.knowledgeList = this.knowledgeList.map((item) => {
        let category = '未学习(-1)';
        if (item.avg_score >= 81) {
          category = '掌握熟练(80~100%)';
        } else if (item.avg_score >= 61) {
          category = '掌握较好(60~79%)';
        } else if (item.avg_score >= 41) {
          category = '掌握一般(40~59%)';
        } else if (item.avg_score >= 21) {
          category = '掌握较弱(20~39%)';
        } else if (item.avg_score >= 0) {
          category = '未掌握(0~19%)';
        }
        return {
          ...item,
          id: item.knowledge_code,
          name: item.knowledge_name,
          category,
        };
      });
    },
    subjectChange() {
      this.isShow = !this.isShow;
    },
    getAccurateCategory(type) {
      getAccurateCategory({
        type,
        crm_subject_id: this.conditionList.crmSubjectId,
        dl_subject_id: this.conditionList.dLSubjectId,
        book_version_id: this.conditionList.bookVersionId,
        grade_id: this.conditionList.gradeId,
        crm_grade_id: this.conditionList.crmGradeId,
      }).then((res) => {
        console.log(res);
        if (res.code === 200) {
          if (type === 'subjects') {
            this.subjectList = res.data;
            this.conditionList.crmSubjectId = this.subjectList[0].crm_subject_id;
            this.conditionList.dLSubjectId = this.subjectList[0].dl_subject_id;
            this.conditionNameList.subjectName = this.subjectList[0].code_name;
            this.getAccurateCategory('versions');
          }
          if (type === 'versions') {
            this.versionsList = res.data;
            this.conditionList.bookVersionId = this.versionsList[0].dl_versions_id;
            this.conditionNameList.versionsName = this.versionsList[0].versions_name;
            this.getAccurateCategory('grade');
          }
          if (type === 'grade') {
            this.gradeList = res.data;
            this.conditionList.gradeId = this.gradeList[0].grade_id;
            this.conditionList.crmGradeId = this.gradeList[0].crm_grade_id;
            this.conditionNameList.gradeName = this.gradeList[0].grade_name;
            this.getAccurateCategory('class');
            this.getAccurateCategory('test');
          }
          if (type === 'class') {
            this.classList = res.data;
            this.value = this.classList[0].class_id || '';
          }
          if (type === 'test') {
            this.testList = res.data;
            this.conditionList.courseCode = this.testList[0].course_code;
            this.conditionList.testId = this.testList[0].test_id;
            this.conditionList.sectionsId = this.testList[0].section_ids;
            this.getClassKnowledgeAtlas();
          }
        }
      });
    },
    add() {
      this.timer = setInterval(() => {
        this.dataList.evaluation_question_num
        += Math.round(10 + Math.random() * 10);
        this.dataList.question_num
        += Math.round(5 + Math.random() * 5);
        this.dataList.question_week_num
        += Math.round(Math.random() * 5);
      }, 30000);
    },
  },
  destroyed() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
  .c {
    padding-top: 40px;
    .fz-20 {
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
    }
    .fz-40 {
      font-size: 40px;
      font-weight: 600;
      color: #00DEFF;
      line-height: 56px;
    }
    &-use{
      display: flex;
    }
    &-condition {
      box-sizing: border-box;
      width: 501px;
      height: 404px;
      padding: 26px 0;
      background: url('../../images/cockpit-box-bg.png') no-repeat top left / cover;
      &__header {
        position: relative;
        font-size: 28px;
        font-weight: 500;
        text-indent: 1em;
        color: #E3E2FF;
        margin-left: 44px;
        &::before {
          content: '';
          position: absolute;
          width: 27px;
          height: 27px;
          top: 9px;
          left: -8px;
          background: url('../../images/cockpit-icon.png') no-repeat center / contain;
        }
      }
      &__flex {
        display: flex;
        justify-content: space-around;
        padding: 0 22px;
      }
      &__number {
        position: relative;
        display: flex;
        flex-direction: column;
        text-align: center;
        justify-content: space-around;
        width: 190px;
        height: 194px;
        margin-top: 53px;
        background: url('../../images/study-data-bg.png') no-repeat top left / 100% 100%;
        &::before {
          content: '';
          position: absolute;
          width: 220px;
          height: 50px;
          bottom: -52px;
          left: -15px;
          background: url('../../images/bg-show.png') no-repeat top left / 100% 100%;
        }
      }
    }
    &-data {
      padding-top: 40px;
      // overflow-x: auto;
      &__analysis {
        display: flex;
        justify-content: space-around;
        margin-top: 30px;
        li {
          width: 278px;
          height: 195px;
          // margin-right: 40px;
          text-align: center;
          background: url('../../images/cockpit-databg.png') no-repeat top left / 100% 100%;
        }
        &__number {
          margin-top: 34px;
          font-size: 20px;
          font-weight: 500;
          line-height: 28px;
        }
      }
        .fz-16{
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        display: flex;
        justify-content: center;
        opacity: 0.6;
        align-items: center;
        .avg_circle{
          display: inline-block;
          width: 5px;
          height: 5px;
          background: #00DEFF;
          border-radius:50% ;
          margin-right:3px ;
        }
        .avg_unit{
          color: #00DEFF;
          margin-left:4px ;
        }
      }
    }
    &-result {
      box-sizing: border-box;
      display: flex;
      padding: 0 20px;
      justify-content: space-around;
      width: 1824px;
      height: 588px;
      margin-top: 42px;
      background: url('../../images/academic_level.png') no-repeat top left / 100% 100%;
       &__effect{
         padding-top: 25px;
       }
       &__header {
        position: relative;
        font-size: 28px;
        font-weight: 500;
        text-indent: 1em;
        color: #E3E2FF;
        // margin-left: 44px;
        margin: 42px 0 30px 0;
        &::before {
          content: '';
          position: absolute;
          width: 27px;
          height: 27px;
          top: 20%;
          left: 0;
          background: url('../../images/cockpit-icon.png') no-repeat center / contain;
        }
      }
      &__flex {
        display: flex;
        justify-content: space-around;
        padding: 0 22px;
      }
      &__number {
        position: relative;
        display: flex;
        flex-direction: column;
        text-align: center;
        justify-content: space-around;
        width: 190px;
        height: 194px;
        margin-top: 53px;
        background: url('../../images/study-data-bg.png') no-repeat top left / 100% 100%;
        &::before {
          content: '';
          position: absolute;
          width: 220px;
          height: 50px;
          bottom: -52px;
          left: -15px;
          background: url('../../images/bg-show.png') no-repeat top left / 100% 100%;
        }
      }
    }
    &-atlas {
      display: flex;
      padding: 0 0 20px 0;
      &__list {
        width: 501px;
        height: 980px;
        overflow: hidden;
        overflow-y: auto;
        margin-right: 24px;
        background: rgba(149, 227, 255, 0.12);
        ul {
          // overflow: auto;
          li {
            box-sizing: border-box;
            width: 496px;
            line-height: 81px;
            font-size: 26px;
            font-weight: 600;
            padding-left: 25px;
          }
        }
        &::-webkit-scrollbar{
          width:5px;
          height:5px;
          /**/
        }
        &::-webkit-scrollbar-track{
          background: #003DA3;
          border-radius:2px;
        }
        &::-webkit-scrollbar-thumb{
          background: #24BAD0;
          border-radius:10px;
        }
        &::-webkit-scrollbar-thumb:hover{
          background: #999;
        }
        &::-webkit-scrollbar-corner{
          background: #204754;
        }
        &__title {
          box-sizing: border-box;
          position: relative;
          width: 501px;
          color: #fff;
          height: 81px;
          line-height: 81px;
          font-size: 26px;
          font-weight: 600;
          padding-left: 25px;
          background: linear-gradient(180deg, rgba(50, 191, 255, 0.62) 0%,
          rgba(107, 70, 252, 0.39) 100%);
        }
      }
    }
    .change-select {
      display: flex;
      justify-content: space-around;
      overflow-y: auto;
      width: 501px;
      height: 480px;
      position: absolute;
      background: #415ACD;
      &__down {
        width: 160px;
        height: 480px;
        border-left: 1px solid #415ACD;
        &__subject {
          width: 105px;
          height: 76px;
          line-height: 76px;
          margin: 0 auto;
          border-bottom: 1px solid #5C73DB;
          text-align: center;
          font-size: 24px;
        }
      }
      .cb3 {
        background-color: #354CB3;
      }
      .w-15 {
        width: 150px;
      }
      &::-webkit-scrollbar{
          width:5px;
          height:5px;
          /**/
        }
        &::-webkit-scrollbar-track{
          background: #003DA3;
          border-radius:2px;
        }
        &::-webkit-scrollbar-thumb{
          background: #24BAD0;
          border-radius:10px;
        }
        &::-webkit-scrollbar-thumb:hover{
          background: #999;
        }
        &::-webkit-scrollbar-corner{
          background: #204754;
        }
    }
    &-border {
      border-bottom: 1px solid rgba(107, 70, 252, 0.39);
    }
  }
  .selectFrom {
    .el-select-dropdown {
    background: rgba(53, 76, 179, 1) !important;
  }
  .el-select-dropdown__empty {
    background: rgba(53, 76, 179, 1) !important;
  }
  }
  .mr-0 {
    margin-left: 0 !important;
  }
  .accurate{
  display: flex;
}
.p-select {
      position: absolute;
      display: flex;
      right: 0;
      top: 0px;
      /deep/ {
         .el-select-dropdown__empty {
           background-color: red ;
  }
        .el-select {
          width: 178px;
          height: 44px;
          .el-input__inner {
            background: url('../..//images/cockpit-time.png') no-repeat top left / 100% 100%;
            border: none;
            color: #F5F5FF;
            .el-icon-arrow-up:before {
              content: '',
            }
          }
        }
      }
    }
  .active {
      color: #00DEFF;
    }
  .right {
    position: absolute;
    right: 30px;
    top: 26px;
  }
  .t-color {
    color: #24BAD0;
  }
  .mr-5{
    margin-right: 5px;
  }
  .bg {
    position: absolute;
    width: 24px;
    height: 1064px;
    left: 500px;
    top: 66px;
    background: url('../../images/cockpit_bg.png') no-repeat left top / 100% 100%;
  }
</style>
